<template>
	<div id="mapBox" class="mapBox" style="width:100%;height:100%">
		<el-dialog :visible.sync='isOpen'>
			<!-- <el-form></el-form> -->
		</el-dialog>
	</div>
</template>

<script>

import icon1 from '../../assets/img/点位.png'
	export default {
		props: ['active'],
		data() {
			return {
				window: "",
				windows: [],
				map: null, //地图实例
				markers: [], //地图点标注
				dialogForm: false,
				formdata: [{
					name: 111
				}],
				events: {
					click: () => {

					}
				},
				// center: [119.461208, 35.428588],
				plugins: [],
				zoom: 10,
			}
		},
		props: {
			selMarker: {
				type: Array,
				default: () => {
					return [];
				}
			},
			dataList:{
				type:Array,
				default:()=>{
					return []
				}
			},
			selMarker:{
				type:Array,
				default:()=>{
					return []
				}
			}
		},
		methods: {
			drawPoint(dataList) {
				
				var that = this;
				that.map = new AMap.Map("mapBox", {
					resizeEnable: true,
					center: [110.284961,21.611281],
					zooms: [10, 17]
				});
				
				var markers = [];
				var firstMarker = null;	
					dataList.map((v, i) => {
						console.log(v,'v')

						var icon = new AMap.Icon({
							// 图标尺寸
							size: new AMap.Size(44, 54),
							// 图标的取图地址
							image:icon1,
							// 图标所用图片大小
							imageSize: new AMap.Size(25, 28),
							// 图标取图偏移量
							// imageOffset: new AMap.Pixel(-9, -3)
						});
						var marker = new AMap.Marker({
							icon,
							position: [v.latlng.split(',')[0], v.latlng.split(',')[1]],
							// bubble:true,
							extData: v,
							map: that.map
						});
						// console.log(`markers${k}`, [v.coordx, v.coordy]);
						markers.push(marker);
						AMap.event.addListener(marker, "click", _onClick);
					})

				
				this.markers = markers;
				// this.map.setCenter([list[Object.keys(list)[0]][0], list[Object.keys(list)[0]][1]]);

				function _onClick(e) {
					var p = e.target;
				
					that.$emit('tableData',p.getExtData())
					// let info =`<ul style="margin: 0;" class="prompt">
					// <img :src="https://tour.i-lianjiang.cn/lianjiang_web_a"+p.getExtData().url></img>
                    // <li>名称：`+(p.getExtData().name||"")+`</li>
                    // <li>位置：`+(p.getExtData().address||"")+`</li>
                    // <li>价格：`+(p.getExtData().price||"")+`</li>
                    // <li>描述：`+(p.getExtData().summary||"")+`</li>
					// <li><button @click='add'>添加行程</button></li>
					// </ul>`

					// let infoWindow = new AMap.InfoWindow({
					// 	autoMove:true,
					// 	isCustom:false,
					// 	content:info,
					// 	closeWhenClickMap: true
					// })
					// infoWindow.open(that.map, e.lnglat)
					that.map.setCenter([p.getPosition().lng, p.getPosition().lat]);
				}
			},
			add(){
				console.log('addList')
			},
			point(dataList) {
				const windows = [];
				const that = this;
				console.log('this.list', list);
				let markers = [];
					dataList.map(v => {
						let marker = {};
						marker.icon = icon1;
						marker.position = [v.latlng.split(',')[0], v.latlng.split(',')[1]];
						marker.template = '<span>1</span>',
							marker.events = {
								click() {
									// 方法：鼠标移动到点标记上，显示相应窗体
									that.windows.forEach((window) => {
										window.visible = false; // 关闭窗体
									});
									that.window = that.windows[index];
									that.$nextTick(() => {
										that.window.visible = true;
									});
								},
							}
						markers.push(marker);
						windows.push({
							position: [v[0], v[1]],
							isCustom: true,
							offset: [115, 55], // 窗体偏移
							showShadow: false,
							visible: false, // 初始是否显示
							address: v.address,
						});
					})

				//  加点
				console.log('markers', markers)
				this.markers = markers;
				// 加弹窗
				this.windows = windows;
			},
			checkDetail() {
				alert("点击了查看详情");
			}
		},
		watch: {
			dataList(n, o) {
				console.log(n,'list')
				this.drawPoint(n)
			},
			selMarker(n, o) {
				console.log(n,'n')
				console.log('selMarker', n)
				this.map.setCenter(n);
			},

		},
		mounted() {
			if (this.dataList) {
				this.drawPoint(this.dataList)
			}
		},

	};
</script>

<style scoped>
	.prompt {
		background: white;
		width: 100px;
		height: 30px;
		text-align: center;
	}

	#info-window {
		width: 211px;
		height: 146px;
		margin-left: 30px;
		background: rgba(255, 255, 255, 0.9);
		border-radius: 4px;
		position: relative;
		overflow: hidden;
	}
</style>